<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Chapter-Title-Page-Break">PART I</p>
<p class="ORIM-Chapter-Subtitle">THE APACHES</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled14.vue?3f8fb2ec